module.exports = __webpack_public_path__ + "img/plumbing-repair-03-square.a8ec60ca.jpg";